import React, { Fragment, memo } from 'react';
import dynamic from 'next/dynamic';
// import ReactHTMLParser from 'react-html-parser';

import _get from 'lodash/get';
import styled from 'styled-components';
// import ShopLayout from '@views/components/shop/ShopLayout';
// import Sidebar from './sub-modules/sidebar';
import Block from '@views/components/block/Block';

// import ProductList from './sub-modules/product-list';
import Seo from './sub-modules/seo';
import RecentlyView from '@views/modules/recent-view/dynamic';
import SubCategoryList from './sub-modules/category-list';

const Header = styled.h1`
  color: var(--primary);
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
`;

const BannerWrapper = styled.div`
  img {
    border-radius: 4px;
    width: 100%;
  }
`;

const ProductList = dynamic(() => import('./sub-modules/product-list'), {
  ssr: false,
  loading: ({ error, isLoading, pastDelay }) => (pastDelay ? <div /> : null),
});

export const Category = ({ id, data }) => {
  return (
    <Fragment>
      <Seo data={data} />
      {/* <ShopLayout>
        <ShopLayout.Sidebar as="nav" className="d-none d-lg-block">
          <Sidebar id={id}/>
        </ShopLayout.Sidebar>
        <ShopLayout.Content> */}
      <SubCategoryList categoryId={id} />
      <Header>{data?.get('name')}</Header>
      {data?.get('bannerUrl') && (
        <BannerWrapper className="mt-3">
          <img
            src={
              data?.get('bannerUrl') ||
              '/assets/banner-category-04-11-2022/BANNER_DDHS_1200x250px.jpg'
            }
            alt={data?.get('name')}
            style={{ width: '100%' }}
          />
        </BannerWrapper>
      )}

      {!!data?.get('description') && (
        <Block>
          <Block.Body className="mt-3">
            <Block.Html>
              <div
                dangerouslySetInnerHTML={{ __html: data?.get('description') }}
              />
              {/* {ReactHTMLParser(data?.get('description'))} */}
            </Block.Html>
          </Block.Body>
        </Block>
      )}
      <ProductList />
      {!!data?.get('longDescription') && (
        <Block>
          <Block.Body className="mb-3 mt-3">
            <Block.Html>
              {/* {ReactHTMLParser(data?.get('longDescription'))} */}
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.get('longDescription'),
                }}
              />
            </Block.Html>
          </Block.Body>
        </Block>
      )}
      <RecentlyView
        breakpoints={{
          375: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            navigation: false,
          },
          567: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            navigation: false,
          },
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          992: {
            slidesPerView: 6,
            slidesPerGroup: 6,
          },
        }}
      />
      {/* </ShopLayout.Content>
      </ShopLayout> */}
    </Fragment>
  );
};

export default memo(Category);
